export default __webpack_public_path__ + "static/media/ctrader_nameless.d1afa963.webp";